import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-container"
}
const _hoisted_2 = {
  key: 1,
  class: "error"
}

import CollapseControllerSummaryNew from './CollapseController/CollapseControllerSummaryNew.vue'
import CardInteractive from './CardInteractive.vue'
import { FormatOptions } from '../formatter'
import { useI18n } from 'vue-i18n'
import { computed, toRefs, inject } from 'vue'
import { DataSource, useDataSources } from '@/composables/useDataSources'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import TextBase from '@/design-system/atoms/TextBase.vue'
import { EntityLevel, useEntityLevel } from '@/composables/useEntityLevel'
import { storeToRefs } from 'pinia'
import { Measurement } from '@/features/dashboard'
import { MeasurementPoint } from '../measurements/contracts'
import { useComponentFilter } from '../measurements/useMeasurements'
import TopListNew from './TopListNew.vue'
import { BarConfiguration } from './toplist-types'
import { sharedDataKey } from '../../types'

type ErrorState = 'NO_DATA' | 'INVALID_FILTER'

type Props = {
  featureName: string
  title: string
  info?: string
  barOptions: BarConfiguration[]
  format: FormatOptions
  dataSource: string
  enabledEntityLevels?: EntityLevel[]
  measurements: Measurement[]
  errorMessages?: Record<ErrorState, string>
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CardTopListNew',
  props: {
    featureName: {},
    title: {},
    info: {},
    barOptions: {},
    format: {},
    dataSource: {},
    enabledEntityLevels: {},
    measurements: {},
    errorMessages: {}
  },
  setup(__props: any) {

const props = __props
const { measurements } = toRefs(props)
const sharedData = inject(sharedDataKey)
const { t } = useI18n()

useComponentFilter(props.featureName, {})
const { getDataSources } = useDataSources()
const { entityLevel } = storeToRefs(useEntityLevel())
const dataSourceIds = computed(() =>
  measurements.value.map(
    (measurement) =>
      `measurements.${props.featureName}.${measurement.name}.${measurement.field.name}.toplist.values`
  )
)
const dashboardFullscreen = computed(() => sharedData?.fullscreen ?? false)
const dataSources = getDataSources<MeasurementPoint[]>(dataSourceIds)

const mergedDataSources = computed<DataSource<MeasurementPoint[]>[]>(() => {
  return dataSources?.value
    ? Object.values(dataSources.value)
        .filter((dataSource) => dataSource !== undefined)
        .map((dataSource) => dataSource!)
    : []
})

const data = computed<MeasurementPoint[]>(() => {
  return mergedDataSources.value
    .filter((ds) => ds.data !== undefined)
    .map((ds) => ds.data!)
    .flat()
})

const isLoading = computed(() => {
  return mergedDataSources.value.every((dataSource) => dataSource.isLoading)
})

const correctFilter = computed(() => {
  if (props.enabledEntityLevels) {
    return props.enabledEntityLevels.includes(entityLevel.value)
  }
  return true
})

const { locale } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['card-chart', { fullscreen: dashboardFullscreen.value }])
  }, [
    _createVNode(CardInteractive, {
      title: _ctx.title,
      info: _ctx.info,
      enableFullscreen: true,
      isLoading: isLoading.value,
      headerDivider: ""
    }, {
      footerControls: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('dashboard__text__selection')) + " : ", 1),
        _createVNode(CollapseControllerSummaryNew, {
          showTimeSelection: true,
          fullscreen: true
        })
      ]),
      default: _withCtx(() => [
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(PulseLoader, {
                loading: true,
                color: "#3F46D6"
              })
            ]))
          : (!correctFilter.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (correctFilter.value)
                  ? (_openBlock(), _createBlock(TextBase, {
                      key: 0,
                      text: _ctx.errorMessages?.NO_DATA[_unref(locale)],
                      type: "label"
                    }, null, 8, ["text"]))
                  : (_openBlock(), _createBlock(TextBase, {
                      key: 1,
                      text: _ctx.errorMessages?.INVALID_FILTER[_unref(locale)],
                      type: "label"
                    }, null, 8, ["text"]))
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (data.value)
                  ? (_openBlock(), _createBlock(TopListNew, {
                      key: 0,
                      data: data.value,
                      format: _ctx.format,
                      barOptions: _ctx.barOptions,
                      locale: _unref(locale)
                    }, null, 8, ["data", "format", "barOptions", "locale"]))
                  : _createCommentVNode("", true)
              ], 64))
      ]),
      _: 1
    }, 8, ["title", "info", "isLoading"])
  ], 2))
}
}

})